// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Banner.module.scss  */
.Banner-module-Root_1Ln {
  position: relative;
  padding: 16px;
  font-family: var(--display-font-family);
  font-size: var(--banner-font-size);
  line-height: var(--banner-line-height);
  background-color: var(--banner-background); }

.Banner-module-Title_1FH,
.Banner-module-Description_QN2 {
  cursor: default;
  white-space: pre-wrap; }

.Banner-module-Title_1FH {
  margin: 0;
  font-weight: 600;
  color: var(--banner-color-title); }

.Banner-module-Description_QN2 {
  margin: 6px 0 0;
  color: var(--banner-color-text); }

.Banner-module-Link_373 {
  display: inline-block;
  margin-top: 6px;
  font-weight: 600; }

.Banner-module-ButtonWrapper_10A {
  margin-top: 16px; }

.Banner-module-rounded_3Vl {
  overflow: hidden;
  border-radius: 16px; }

.Banner-module-withShadow_33C {
  box-shadow: 4px 8px 15px rgba(0, 0, 0, 0.05); }

.Banner-module-centerContentPosition_hJf {
  display: flex;
  flex-direction: column;
  align-items: center; }
  .Banner-module-centerContentPosition_hJf .Banner-module-Content_3uc {
    text-align: center; }
  .Banner-module-centerContentPosition_hJf .Banner-module-Addon_1iJ {
    margin-bottom: 10px; }

.Banner-module-leftContentPosition_1Et,
.Banner-module-rightContentPosition_Ci7 {
  display: flex;
  align-items: center; }

.Banner-module-leftContentPosition_1Et {
  flex-direction: row-reverse; }
  .Banner-module-leftContentPosition_1Et .Banner-module-Addon_1iJ {
    margin-left: 19px; }

.Banner-module-rightContentPosition_Ci7 .Banner-module-Addon_1iJ {
  margin-right: 19px; }

.Banner-module-Close_1-m {
  position: absolute;
  z-index: 2;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: var(--banner-color-icon); }

.Banner-module-Close_1-m,
.Banner-module-CloseIcon_1eQ {
  width: 20px;
  height: 20px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Banner/Banner.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C,EAAE;;AAE9C;;EAEE,eAAe;EACf,qBAAqB,EAAE;;AAEzB;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC,EAAE;;AAEpC;EACE,eAAe;EACf,+BAA+B,EAAE;;AAEnC;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB;EAChB,mBAAmB,EAAE;;AAEvB;EACE,4CAA4C,EAAE;;AAEhD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE;EACrB;IACE,kBAAkB,EAAE;EACtB;IACE,mBAAmB,EAAE;;AAEzB;;EAEE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;EACE,2BAA2B,EAAE;EAC7B;IACE,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,eAAe;EACf,+BAA+B,EAAE;;AAEnC;;EAEE,WAAW;EACX,YAAY,EAAE","sourcesContent":["/*  imported from Banner.module.scss  */\n.Banner-module-Root_1Ln {\n  position: relative;\n  padding: 16px;\n  font-family: var(--display-font-family);\n  font-size: var(--banner-font-size);\n  line-height: var(--banner-line-height);\n  background-color: var(--banner-background); }\n\n.Banner-module-Title_1FH,\n.Banner-module-Description_QN2 {\n  cursor: default;\n  white-space: pre-wrap; }\n\n.Banner-module-Title_1FH {\n  margin: 0;\n  font-weight: 600;\n  color: var(--banner-color-title); }\n\n.Banner-module-Description_QN2 {\n  margin: 6px 0 0;\n  color: var(--banner-color-text); }\n\n.Banner-module-Link_373 {\n  display: inline-block;\n  margin-top: 6px;\n  font-weight: 600; }\n\n.Banner-module-ButtonWrapper_10A {\n  margin-top: 16px; }\n\n.Banner-module-rounded_3Vl {\n  overflow: hidden;\n  border-radius: 16px; }\n\n.Banner-module-withShadow_33C {\n  box-shadow: 4px 8px 15px rgba(0, 0, 0, 0.05); }\n\n.Banner-module-centerContentPosition_hJf {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n  .Banner-module-centerContentPosition_hJf .Banner-module-Content_3uc {\n    text-align: center; }\n  .Banner-module-centerContentPosition_hJf .Banner-module-Addon_1iJ {\n    margin-bottom: 10px; }\n\n.Banner-module-leftContentPosition_1Et,\n.Banner-module-rightContentPosition_Ci7 {\n  display: flex;\n  align-items: center; }\n\n.Banner-module-leftContentPosition_1Et {\n  flex-direction: row-reverse; }\n  .Banner-module-leftContentPosition_1Et .Banner-module-Addon_1iJ {\n    margin-left: 19px; }\n\n.Banner-module-rightContentPosition_Ci7 .Banner-module-Addon_1iJ {\n  margin-right: 19px; }\n\n.Banner-module-Close_1-m {\n  position: absolute;\n  z-index: 2;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  color: var(--banner-color-icon); }\n\n.Banner-module-Close_1-m,\n.Banner-module-CloseIcon_1eQ {\n  width: 20px;\n  height: 20px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
